__turbopack_context__.v({
  "abilityInput": "master-module__ElL5bW__abilityInput",
  "abilityInputs": "master-module__ElL5bW__abilityInputs",
  "abilityTotal": "master-module__ElL5bW__abilityTotal",
  "choice": "master-module__ElL5bW__choice",
  "choiceLabel": "master-module__ElL5bW__choiceLabel",
  "choices": "master-module__ElL5bW__choices",
  "classCaption": "master-module__ElL5bW__classCaption",
  "classError": "master-module__ElL5bW__classError",
  "classHeader": "master-module__ElL5bW__classHeader",
  "classHeaderActions": "master-module__ElL5bW__classHeaderActions",
  "classHeaderTitle": "master-module__ElL5bW__classHeaderTitle",
  "classIcon": "master-module__ElL5bW__classIcon",
  "classSection": "master-module__ElL5bW__classSection",
  "classSectionError": "master-module__ElL5bW__classSectionError",
  "classTitle": "master-module__ElL5bW__classTitle",
  "description": "master-module__ElL5bW__description",
  "descriptionClamped": "master-module__ElL5bW__descriptionClamped",
  "feature": "master-module__ElL5bW__feature",
  "featureCaption": "master-module__ElL5bW__featureCaption",
  "featureError": "master-module__ElL5bW__featureError",
  "featureErrorText": "master-module__ElL5bW__featureErrorText",
  "featureNeedsChoice": "master-module__ElL5bW__featureNeedsChoice",
  "featureTitle": "master-module__ElL5bW__featureTitle",
  "hint": "master-module__ElL5bW__hint",
  "levelSelect": "master-module__ElL5bW__levelSelect",
  "lockedChoice": "master-module__ElL5bW__lockedChoice",
  "masterButtons": "master-module__ElL5bW__masterButtons",
  "masterFooter": "master-module__ElL5bW__masterFooter",
  "nestedChoices": "master-module__ElL5bW__nestedChoices",
  "originFacts": "master-module__ElL5bW__originFacts",
  "pickBlocker": "master-module__ElL5bW__pickBlocker",
  "pickCaption": "master-module__ElL5bW__pickCaption",
  "pickList": "master-module__ElL5bW__pickList",
  "pickText": "master-module__ElL5bW__pickText",
  "pickTitle": "master-module__ElL5bW__pickTitle",
  "pointBuyLeft": "master-module__ElL5bW__pointBuyLeft",
  "required": "master-module__ElL5bW__required",
  "rollGroup": "master-module__ElL5bW__rollGroup",
  "rollSlot": "master-module__ElL5bW__rollSlot",
  "rollSlots": "master-module__ElL5bW__rollSlots",
  "rollTotal": "master-module__ElL5bW__rollTotal",
  "selectedTitle": "master-module__ElL5bW__selectedTitle",
  "startingEquipment": "master-module__ElL5bW__startingEquipment",
  "startingTitle": "master-module__ElL5bW__startingTitle",
  "stepBar": "master-module__ElL5bW__stepBar",
  "stepTab": "master-module__ElL5bW__stepTab",
  "stepTabCurrent": "master-module__ElL5bW__stepTabCurrent",
  "stepTabError": "master-module__ElL5bW__stepTabError",
  "stepTabNumber": "master-module__ElL5bW__stepTabNumber",
});
